import styled from 'styled-components';

import {
  Table as SemanticTable,
} from 'semantic-ui-react';

import { Text as TextLayoutComponent } from '@playbookux/playbook-web-core';

export const Table = styled(SemanticTable)``;

export const Text = styled(TextLayoutComponent)``;

export const Link = styled.a``;
